import React from 'react'

// Which automation a setting belongs to, and at what level it applies. The sentence under each
// section header (AmazonSettingsSectionHeader) says the same in words, so nothing depends on hovering.
const SCOPE_STYLES = {
    all: 'bg-primary-subtle text-primary-emphasis border-primary-subtle',
    anomaly: 'bg-info-subtle text-info-emphasis border-info-subtle',
    bidding: 'bg-success-subtle text-success-emphasis border-success-subtle',
    global: 'bg-secondary-subtle text-secondary-emphasis border-secondary-subtle',
}

export const AmazonScopeChip = ({ scope = 'all', children }) => (
    <span className={`badge rounded-pill border fw-semibold ${SCOPE_STYLES[scope] || SCOPE_STYLES.all}`}>
        {children}
    </span>
)

/** Section title with its scope chip and the always-visible scope sentence. */
export const AmazonSettingsSectionHeader = ({ title, scope, scopeLabel, sentence, actions = null }) => (
    <div className="mb-3">
        <div className="d-flex flex-wrap justify-content-between align-items-center gap-2">
            <div className="d-flex flex-wrap align-items-center gap-2">
                <h5 className="mb-0">{title}</h5>
                {scopeLabel && <AmazonScopeChip scope={scope}>{scopeLabel}</AmazonScopeChip>}
            </div>
            {actions}
        </div>
        {sentence && <div className="text-body-secondary small mt-1">{sentence}</div>}
    </div>
)

export default AmazonScopeChip
